import {AppRouting} from "./routes";
import "font-awesome/css/font-awesome.min.css";
import {store} from "./store/store";
import {Provider} from "react-redux";
import Aside from "./layout/aside/Aside.layout";
import {BrowserRouter} from "react-router-dom";
import {useEffect} from "react";

function App() {
    useEffect(() => {
        localStorage.setItem("customUpdateState", "false")
    }, []);

    return (
        <Provider store={store}>
            <BrowserRouter>
                <Aside/>
                <AppRouting/>
            </BrowserRouter>
        </Provider>
    );
}

export default App;
